<div *ngIf="productList" class="product__section" [ngClass]="{'product__section--cms': isCms}">
  <div class="innerContainer">
    <h2 class="vc-title-m product__section__title">{{ title }}</h2>
    <vc-products-arrangement
      [items]="productList"
      [seoContext]="seoContext"
      [isSlider]="isSlider"
      [itemMax]="itemMax"
      [trackingTitle]="trackingTitle"
      (productClick)="onProductClick($event)"
      (moduleScroll)="onModuleScroll($event)"
      (moduleDisplay)="onModuleDisplay($event)"
    ></vc-products-arrangement>
  </div>
</div>
